import * as React from 'react';
import Page from 'components/Page';
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';

import { Row, Col, FormGroup} from 'reactstrap';

// import { Bar, Doughnut, } from 'react-chartjs-2';

import BaseService from '../services/BaseService';

class ReportWallet extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isloaded: false,
            date_from: this.returnDate(),
            date_to: this.returnDate("to"),
            date_today: this.returnDate("hoje"),
            reportData: [],
            reportTotal: [],
            reportGroup: []
        };
    
        this.handleInputChange = this.handleInputChange.bind(this);     
        this.onPlaque = this.onPlaque.bind(this);  
    }

    onPlaque() { 
        this.componentDidMount(); }

    returnDate(type) {var da = new Date();
        var year = da.getFullYear();
        var month = da.getMonth() + 1;
        var day = da.getDate();
        // var data = new Date(year, month, 0);

        if (da.getMonth() + 1 < 10) {
            month = "0" + (da.getMonth() + 1);}

        if (type === "to") {
            return year + "-" + month + "-" + day;
        } else if (type === "today") {
            return year + "-" + month + "-" + day;
        } else if (type === "hoje") {
            return day + "/" + month + "/" + year;
        } else { 
            day = "01"; return year + "-" + month + "-" + day;}
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }     

    renderAPI = () => {

        var date1 = this.state.date_from;
        var date2 = this.state.date_to;
        date1 = date1.replace("/", "-").replace("/", "-");
        date2 = date2.replace("/", "-").replace("/", "-");

        fetch(BaseService.ENDPOINT + "admin/statistics/report-wallet?ini_date=" + date1 + "&end_date=" + date2, {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.props.user.access_token
            })
        })
        .then(res => res.json())
        .then(res => { 
            this.setState({
                reportData: res.data.results,
                // reportGroup: res.data.group,
                reportTotal: res.data.total,
                isloaded: true  
            })
        })   

        console.log(BaseService.ENDPOINT + "admin/statistics/report-cash?ini_date=" + date1 + "&end_date=" + date2)
        console.log(this.props.user.access_token)
        
    }  

    componentDidMount(){    
        this.renderAPI()
    }

    renderListHeader() {
        if (this.state.isloaded){
            return(
                <thead>
                <tr>
                    <th>Tipo</th>
                    <th>Nome</th>
                    <th>E-mail</th>
                    <th>Saldo</th>
                </tr>
                </thead>
            )
        }
    }
    
    renderListBody() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return this.state.reportData.map((ret)=>{return(
                <tr key={ret.id}>
                    <td>{ret.Tipo}</td>
                    <td>{ret.Nome}</td>
                    <td>{ret.Email}</td>
                    <td align='right'>{numberFormat(ret.Saldo)}</td>
                </tr>
            )})

        } else { return <span><strong>Carregando...</strong></span> }
     }    

     renderListFooter() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return(
                <tfoot class='rdp'>
                <tr>
                    <td></td>
                    <td></td>
                    <td><strong>Total em {this.state.date_today}</strong></td>
                    <td align='right'><strong>{numberFormat(this.state.reportTotal[0].Total)}</strong></td>
                </tr>
                </tfoot>
            )
        }         
     }

     renderListGroupFooter() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return(
                <tfoot>
                <tr>
                    <td><strong>Total em {this.state.date_today}</strong></td>
                    <td align='right'><strong>{numberFormat(this.state.reportTotal[0].Total)}</strong></td>
                </tr>
            </tfoot>     
            )
        }
     }  

    render() {
        return (
            <Page
                title="Carteira Flutuante"
                className="ReportWallet"
                style={{
                    minHeight: '84vh'
                }}>
                <style>{"\
                    table {\
                        background: #FFFFFF;\
                        width: 100%;\
                    }\
                    tr {\
                        border: 1px solid #C9C9C9;\
                    }\
                    th {\
                        // background: green;\
                        // color: #FFFFFF;\
                        font-weight: bold;\
                        border-bottom: 2px solid #C9C9C9;\
                        padding: 15px;\
                    }\
                    td {\
                        max-width: 400px;\
                        overflow: hidden;\
                        text-overflow: ellipsis;\
                        white-space: nowrap;\
                        padding: 10px;\
                    }\
                    tfoot{\
                        font-weight: bold !important;\
                        border-top: 2px solid #C9C9C9;\
                        border-bottom: 2px solid #C9C9C9;\
                        padding: 15px;\
                    }\
                    .total {\
                        background: green;\
                        color: #FFFFFF;\
                    }\
                "}</style>

                <Row>
                <FormGroup style={{ marginLeft: 15, width: '95%'}}>

                    <Row>
                        <Col sm={12} className="mb-3">
                            <table id='reportGroup' class='total'>
                                {this.renderListGroupFooter()}                            
                            </table>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            <small>
                            <table id='repotList'>
                                {this.renderListHeader()}
                                <tbody>{this.renderListBody()}</tbody>
                                {this.renderListFooter()}
                            </table>
                            </small>
                        </Col>
                    </Row>

                </FormGroup>
                </Row>

            </Page>
        );
    }
};


// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
    const currentUser = loginSelectors.getUser(state);
    return {
        user: currentUser
    };
}
export default connect(mapStateToProps)(ReportWallet)


// WEBPACK FOOTER //
// ./src/pages/ReportWallet.js